export const getServiceTypesFrag = `
    id
    name
    type
    expertise {
        code
        name
    }
`;

export const getExpertisesFrag = `
    code
`;
